import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from "@backstage/core-plugin-api";
import { datadogApiRef, DatadogApi } from "./api/DatadogApi";
import { rootRouteRef } from "./routes";

export const datadogApiPlugin = createPlugin({
  id: "datadog-api",
  apis: [
    createApiFactory({
      api: datadogApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new DatadogApi({
          discoveryApi,
          identityApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});
